<div class="container" loading-spin [isLoading]="isPageLoading" [loadingSize]="'big'" [loadingLevel]="110">
    <tam-splitter splitterBarWidth=3 [useTransition]="300">
        <tam-splitter-panel [size]="toplistView.refinedByWidth" [max]="toplistView.refinedByMax"
            [min]="toplistView.refinedByMin" [visible]="refineByShow" (collapsedChange)="collapsedChange($event)">
            <div class="refineby">
                <blastemail-refineby [config]="refinebyConfig"></blastemail-refineby>
            </div>
            <smart-icon tid="refine_by_icon" name="layout-collapse-o" class="collapse light" (click)="collapse()"
                *ngIf="refineByShow===true"></smart-icon>
        </tam-splitter-panel>
        <tam-splitter-panel [size]="toplistView.previewWidth">
            <tam-splitter [direction]="'vertical'" splitterBarWidth=3>
                <tam-splitter-panel [size]="toplistView.toplistHeight" [max]="toplistView.toplistMax"
                    [min]="toplistView.toplistmin">
                    <div tid="note-list-panel" class="list-container">
                        <div class="tool-bar">
                            <div class="search-box">
                                <div class="hider" [hidden]="!config||config.hideKeyword">
                                    <keyword-search [config]="keywordSearchConfig">
                                    </keyword-search>
                                </div>
                                <div class="counter-box">
                                    <span>{{blastEmailListTotalCount}} items</span>
                                </div>
                            </div>
                            <div class="button-box" kendoTooltip tooltipClass="tooltip-adjust-right">
                                <smart-icon tid="refresh_icon" name="refresh" (click)="refresh($event)" class="light"
                                    title="Refresh">
                                </smart-icon>
                            </div>
                        </div>
                        <div *ngIf="blastEmailListConfig" class="list-pane">
                            <top-blastemail-list [config]="blastEmailListConfig"
                                (quickDeposit)="onClickQuickDeposit($event)"
                                (normalDeposit)="onClickNormalDeposit($event)">
                            </top-blastemail-list>
                        </div>
                    </div>
                </tam-splitter-panel>
                <tam-splitter-panel [size]="toplistView.previewHeight" [max]="toplistView.previewMax"
                    [min]="toplistView.previewmin">
                    <div class="blastemail-detail-box" loading-spin [isLoading]="isBlastEmailDetailLoading"
                        [loadingSize]="'big'">
                        <blastemail-detail *ngIf="!isBlastEmailDetailLoading" [config]="blastEmailDetailConfig"
                            (quickDeposit)="onClickQuickDeposit($event)" (normalDeposit)="onClickNormalDeposit($event)"
                            (quickAddContact)="onClickQuickAddContact($event)" (AddContact)="onClickAddContact($event)">
                        </blastemail-detail>
                    </div>
                </tam-splitter-panel>
            </tam-splitter>
        </tam-splitter-panel>
    </tam-splitter>
    <smart-icon name="layout-expand-o" tid="refine_by_icon" class="expand light" (click)="collapse()"
        *ngIf="refineByShow===false"></smart-icon>
</div>